<script>
export default {
  name: 'IconFpCar',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 11l1.6-4.2A2 2 0 0 1 7.5 5.5h9a2 2 0 0 1 1.9 1.3L20 11" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3 11h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 17H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <circle cx="7" cy="17.5" r="1.8" :stroke="color" stroke-width="1.6" />
    <circle cx="17" cy="17.5" r="1.8" :stroke="color" stroke-width="1.6" />
  </svg>
</template>
